import React from 'react';
import Icon from '../../../components/AppIcon';

const AboutUsSection = () => {
  const team = [
    { name: 'Miroslav', role: 'CEO & Co-Founder', icon: 'User' },
    { name: 'Milena', role: 'CTO & Co-Founder', icon: 'User' },
    { name: 'Dragomir', role: 'CPO & Co-Founder', icon: 'User' }
  ];

  return (
    <section className="py-24 bg-[#0B1220]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#FFD100]/10 border border-[#FFD100]/20 rounded-full px-4 py-2 mb-6">
            <Icon name="Globe" size={16} color="#FFD100" />
            <span className="text-[#FFD100] text-sm font-semibold">OUR STORY</span>
          </div>
          <h2 className="text-5xl font-bold text-white mb-6">
            Born in Belgrade.<br />
            <span className="text-[#FFD100]">Built for the world.</span>
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto leading-relaxed">
            We experienced firsthand how chaotic onboarding costs companies millions in lost productivity and talent. 
            First On Date was born from a simple mission: make every employee's first day feel like their best day.
          </p>
        </div>

        {/* Team */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {team?.map((member, index) => (
            <div
              key={index}
              className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-3xl p-8 hover:bg-white/10 hover:border-[#FFD100]/40 hover:shadow-xl hover:shadow-[#FFD100]/10 transition-all duration-300 text-center">
              <div className="w-24 h-24 bg-[#FFD100]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <Icon name={member?.icon} size={40} color="#FFD100" strokeWidth={2} />
              </div>
              <h4 className="text-xl font-bold text-white mb-2">{member?.name}</h4>
              <p className="text-white/60">{member?.role}</p>
            </div>
          ))}
        </div>

        {/* Mission Statement */}
        <div className="backdrop-blur-xl bg-gradient-to-r from-[#FFD100]/10 to-[#FFD100]/5 border border-[#FFD100]/30 rounded-3xl p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-6">Our Mission</h3>
          <p className="text-xl text-white/80 max-w-4xl mx-auto leading-relaxed">
            To transform employee onboarding from a compliance checkbox into a strategic advantage, 
            helping companies retain talent, boost productivity, and build cultures where people thrive from day one.
          </p>
          <div className="mt-8 flex gap-8 justify-center items-center text-white/60">
            <div className="text-center">
              <div className="text-3xl font-bold text-[#FFD100] mb-1">50K+</div>
              <p className="text-sm">Employees Onboarded</p>
            </div>
            <div className="w-px h-12 bg-white/20"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#FFD100] mb-1">200+</div>
              <p className="text-sm">Enterprise Clients</p>
            </div>
            <div className="w-px h-12 bg-white/20"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#FFD100] mb-1">45</div>
              <p className="text-sm">Countries</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;